const Layout = () => import('@/components/Layout')
const Home = () => import('@/views/home')
const CooperateCase = () => import('@/views/cooperation-case')
// const BusinessMap = () => import('@/views/business-map')
const About = () => import('@/views/about')
const Venues = () => import('@/views/product/venues')
const Training = () => import('@/views/product/training')
const Fitness = () => import('@/views/product/fitness')


export default [{
  path: '/',
  name: 'Layout',
  component: Layout,
  children: [{
    path: '/',
    name: 'home',
    component: Home,
  }, {
    path: '/cooperation-case',
    name: 'cooperateCase',
    component: CooperateCase,
  }, {
    path: '/about',
    name: 'about',
    component: About,
  }, {
    path: '/venues',
    name: 'venues',
    component: Venues,
  }, {
    path: '/training',
    name: 'training',
    component: Training,
  }, {
    path: '/fitness',
    name: 'fitness',
    component: Fitness,
  }],
}, {
  path: '*',
  redirect: '/'
}]



// WEBPACK FOOTER //
// ./src/router/routes.js